import 'slick-carousel';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    /** Hero */
    function heroSliderSettings() {
      return {
        slidesToShow: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        fade: true,
      }
    }
    $('.hero-slider').slick(heroSliderSettings());

    /** Offers */
    function offersSliderSettings() {
      return {
        slidesToShow: 3,
        dots: true,
        arrows: false,
        autoplay: true,
        variableHeight: true,
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            arrows: false,
          },
        }],
      }
    }
    $('.offers-slider').slick(offersSliderSettings());
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js